import { prompt, type PromptDefinition } from './models';

export const SUSTAINABILITY_MANAGER_PROMPTS = [
    prompt(
        'Improve performance',
        'What sustainability targets and baselines are documented for this building?',
        'Which buildings have sustainability targets without a documented baseline?'
    ),
    prompt(
        'Improve performance',
        'What environmental certifications are current for this building?',
        'Compare current environmental certifications across my buildings.'
    ),
    prompt(
        'Improve performance',
        'Which sustainability actions are recommended for this building?',
        'Which buildings have documented sustainability actions to prioritise?'
    ),
    prompt(
        'Improve performance',
        'Find sustainability assessment evidence for this building about…',
        'Find sustainability assessment evidence across my buildings about…',
        'prefill'
    ),
    prompt(
        'Improve performance',
        'What emissions information is available for this building, and what is excluded?',
        'Which buildings have incomplete emissions information or inconsistent reporting boundaries?'
    ),
    prompt(
        'Improve performance',
        'What water and waste performance is recorded for this building?',
        'Compare documented water and waste performance across my buildings.'
    ),
    prompt(
        'Improve performance',
        "What evidence supports this building's environmental performance claims?",
        'Which buildings have environmental claims without supporting evidence?'
    ),
    prompt(
        'Improve performance',
        'Find carbon or emissions reports for this building covering…',
        'Find carbon or emissions reports across my buildings covering…',
        'prefill'
    ),
    prompt(
        'Improve performance',
        "Which material or refurbishment choices are documented for this building's sustainability goals?",
        'Compare documented sustainable material and refurbishment choices across my buildings.'
    ),
    prompt(
        'Improve performance',
        'What climate-resilience findings are recorded for this building?',
        'Which buildings have documented climate-resilience gaps?'
    ),
    prompt(
        'Improve performance',
        "What progress is evidenced against this building's sustainability action plan?",
        'Which buildings lack evidence of progress against sustainability action plans?'
    ),
    prompt(
        'Improve performance',
        'Prepare a sustainability evidence summary for this building focused on…',
        'Compare sustainability progress across my buildings focused on…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
